
Vue.component("notice_card", {
  props: {
      cardData: {
          type: Object,
          required: true,
          default: () => ({})
      }
  },
  data() {
      return {
          isOverflow: true,
          hasMore: true
      }
  },
  mounted() {
      console.info(111111)
      this.$nextTick(() => {
          console.info(this.cardData)
          this.moreBtnInit()
      })
  },
  methods: {
      expandHandle() {
          console.info(this.cardData)
          this.isOverflow = !this.isOverflow
      },
      moreBtnInit() {
          let oraginHeight = this.$refs.contentRef.clientHeight
          this.hasMore = false
          this.$nextTick(() => {
              let relHeight = this.$refs.contentRef.clientHeight
              if (relHeight > oraginHeight) {
                  this.hasMore = true
              }
          })
      }
  },
  template: `
<el-card class="box-card">
  <div slot="header" class="clearfix">
    <span>{{cardData.title}}</span>
  </div>
  <div class="teacher-container">
    <span>{{cardData.createUserName}}</span>
    <span>{{dateFormate(cardData.publishTime, "y-m-d h:i:s")}}</span>
  </div>
  <div ref="contentRef" :class="{'content-container': true, isOverflow: isOverflow && hasMore}">
    {{cardData.content}}
  </div>
  <div class="btn-container" v-if="hasMore">
    <div @click="expandHandle">
      <span>{{isOverflow ? $t('展开') : $t('收起')}}{{$t('全部')}}</span>
      <i v-if="isOverflow" class="el-icon-arrow-down"></i>
      <i v-else class="el-icon-arrow-up"></i>
    </div>
  </div>
</el-card>`
});